"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * CardScan API
 * The official documentation for the CardScan API Clients.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanCaptureType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.ScanCaptureType = {
    Manual: 'manual',
    Automatic: 'automatic',
    SelectedFile: 'selectedFile',
    Api: 'api'
};
